module.exports = __webpack_public_path__ + "img/18.bfd81bf9.svg";